export function normalizePhone(raw: string | number | undefined | null): {
  international: string;
  display: string;
  whatsapp: string;
  tel: string;
} {
  const fallback = { international: "", display: "", whatsapp: "", tel: "" };
  if (!raw) return fallback;

  let digits = String(raw).replace(/[^0-9]/g, "");
  if (!digits) return fallback;

  if (digits.startsWith("0039")) {
    digits = digits.slice(4);
  } else if (digits.startsWith("39") && digits.length > 9) {
    digits = digits.slice(2);
  }

  const full = "39" + digits;

  const isMobile = digits.startsWith("3");
  let display: string;
  if (isMobile && digits.length === 10) {
    display = `+39 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  } else if (digits.startsWith("0")) {
    const areaLen = digits.startsWith("06") || digits.startsWith("02") ? 2 : 3;
    display = `+39 ${digits.slice(0, areaLen)} ${digits.slice(areaLen)}`;
  } else {
    display = `+${full}`;
  }

  return {
    international: `+${full}`,
    display,
    whatsapp: full,
    tel: `+${full}`,
  };
}
